export default {
  pageTitle: {
    index: '{title}',
    report: 'گزارش {title}',
    create: 'افزودن {title}',
    edit: 'ویرایش {title} - {id}',
    detail: 'جزئیات {title} - {id}'
  }
}
